enum CARD_TYPE {
  HEART,
  DIAMOND,
  SPADE,
  CLUB,
}

export { CARD_TYPE }
